import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useAuthContext } from '../../contexts/authContext';
import { AppContext } from '../../pages/layout';

function LoggedUserInfo(): JSX.Element {
  const { t } = useTranslation();

  const { logOut, user } = useAuthContext();
  const appContext = useContext(AppContext);
  const open: boolean = appContext?.toggle!;

  const navFootRef = useRef<HTMLInputElement | null>(null);

  const changeValue = (): void => {
    appContext?.changeToggle();
  };

  const handleLogout = (): void => {
    logOut();
  };

  return (
    <>
      {user && (
        <Box
          sx={{ position: 'relative', background: '#fff', mt: 'auto', pt: '12px' }}
          className="footer-content"
          ref={navFootRef}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
              position: 'relative',
              pb: '12px',
            }}
          >
            <Box
              onClick={changeValue}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                columnGap: '10px',
                pl: '20px',
                cursor: 'pointer',
                alignItems: 'center',
                opacity: 0.4,
                ':hover': { opacity: 1 },
              }}
            >
              <ArrowCircleDownIcon
                sx={{
                  color: '#212121',
                  transform: open ? 'rotate(90deg)' : 'rotate(-90deg)',
                }}
              />
              {open && (
                <Box sx={{ fontSize: '13px', fontWeight: '600', color: '#212121' }}>
                  {t('action_buttons.collapse_menu')}
                </Box>
              )}
            </Box>
          </Box>
          <Box className="dropdown" sx={{ background: '#2196f3', ':hover': { background: '#0184eb !important' } }}>
            <Box
              component={Link}
              to={'#'}
              className="dropbtn"
              sx={{
                pt: '15px',
                pb: '12px',
                position: 'relative',
                display: 'flex',
                columnGap: '10px',
                pl: open ? '13px' : '13px',
              }}
            >
              <Avatar
                sx={{
                  width: 38,
                  height: 38,
                  fontSize: '12px',
                  background: '#fff',
                  mx: 'auto',
                  color: '#000',
                }}
              >
                <>{user.first_name.substring(0, 1) + user.last_name.substring(0, 1)}</>
              </Avatar>
              {open && (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ fontSize: '14px', fontWeight: '600', color: '#fff', position: 'relative', top: '1px' }}>
                    {`${user.first_name} ${user.last_name}`}
                  </Box>
                  <Box sx={{ fontSize: '11px', fontWeight: '400', color: '#dfdfdf' }}>{user.role}</Box>
                </Box>
              )}
            </Box>
            <Box
              className="dropdown-content"
              sx={{
                left: open ? '219px' : '64px',
                bottom: '0',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Link to={`/settings/users/${user.userId}`}>{t('user.profile')}</Link>
                <Link to={`/settings/users/${user.userId}/change-password`}>
                  {t('forgot_password.send_reset_link_btn')}
                </Link>
                <Link onClick={handleLogout} to={'#'}>
                  {t('user.log_out')}
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}

export default LoggedUserInfo;
